import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';

// components
import { SbSharedRefineMenuCaratWeight } from '../../SbSharedRefineMenu/SbSharedRefineMenuCaratWeight/SbSharedRefineMenuCaratWeight.tsx';

import { type FilterValue } from '../../SbSharedRefineMenu/SbSharedRefineMenuMultiSelect/SbSharedRefineMenuMultiSelect.tsx';
import { type SbRespRefineMenuFilterCaratWeight_itemSearch$key } from './__generated__/SbRespRefineMenuFilterCaratWeight_itemSearch.graphql.ts';

const itemSearchFragment = graphql`
    fragment SbRespRefineMenuFilterCaratWeight_itemSearch on ItemSearchQueryConnection {
        ...SbSharedRefineMenuCaratWeight_itemSearch
    }
`;

type Props = {
    itemSearch: SbRespRefineMenuFilterCaratWeight_itemSearch$key;
    filterName: string;
    filter: { values: ReadonlyArray<FilterValue | null | undefined> } | null | undefined;
};

export const SbRespRefineMenuFilterCaratWeight: FC<Props> = ({
    itemSearch: itemSearchRef,
    filterName,
    filter,
}) => {
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);
    return (
        <SbSharedRefineMenuCaratWeight
            itemSearch={itemSearch}
            filterName={filterName}
            filter={filter}
        />
    );
};
